import { DateType } from '@date-io/type'
import styled from '@emotion/styled'
import { TextField } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import React from 'react'

const CustomTextField = styled(TextField)`
	width: 150px;
	.MuiInputBase-root {
		height: 45px;
		border: 2px solid #fff;
		border-radius: 0;
	}
	.MuiOutlinedInput-notchedOutline {
		border: 0;
	}
`
interface IProps {
	selectedValue: string
	onChangeHandler: (
		date: DateType | null,
		keyboardValue: string | undefined
	) => void
}
const Datepicker = (props: IProps) => {
	const { selectedValue, onChangeHandler } = props
	return (
		<DatePicker
			views={['month', 'year']}
			inputFormat="MM/yyyy"
			value={selectedValue}
			onChange={onChangeHandler}
			openTo="month"
			renderInput={params => <CustomTextField variant="outlined" {...params} />}
		/>
	)
}
export { Datepicker }
